import z from 'zod';

export const publicEnvConfigSchema = z.object({
    APP_ENV: z.string(),
    CLERK_PUBLISHABLE_KEY: z.string(),
    INTERCOM_APP_ID: z.string().optional(),
    POSTHOG_HOST: z.string().optional(),
    POSTHOG_KEY: z.string().optional(),
    UPLOADCARE_CDN_NAME: z.string().optional(),
    UPLOADCARE_PUBLIC_KEY: z.string().optional(),
});

export type PublicEnvConfig = z.infer<typeof publicEnvConfigSchema>;
